import React, { useEffect, useState } from 'react';
import rama2 from '../../../../assets/rama2.png';
import rama1 from '../../../../assets/rama1.png';
import { MusicLibrary } from '../../../../assets/icons';
import { SongsFinder, Alert } from '../../../../components';
import { Content } from './partials';
import { sendMusic } from './actions';

const TOP_ARTISTS = ['One Direction'];

export const Music = () => {
  const [alert, setAlert] = useState(null);

  const handleSongClick = async (song) => {
    const userToken = localStorage.getItem('userToken');

    const sendBody = {
      userToken,
      id: song.id,
      name: song.name,
      artist: song.artist,
      url: song.url,
      image: song.image[0]?.url || '',
    };

    const result = await sendMusic(sendBody);

    console.log('result', result);
    if (result.code === 200) {
      const isTopArtist = TOP_ARTISTS.includes(sendBody.artist);

      setAlert({
        code: 200,
        title: isTopArtist ? '¡Temazo!' : '¡Gracias!',
        body: 'Hemos añadido esta canción a la playlist',
        emoji: '😋',
      });
    } else {
      setAlert({
        code: result.code,
        title: 'Vaya! Ha ocurrido un error',
        body: 'Prueba de nuevo por favor.',
        emoji: '😔',
      });
    }
  };

  return (
    <>
      {alert && <Alert {...alert} onClose={() => setAlert(null)} />}

      <Content>
        <img className="rama2" src={rama2} alt="Rama decorativa" />
        <h2>¡Forma parte de la celebración!</h2>
        <img className="rama1" src={rama1} alt="Rama decorativa" />

        <div className="text">
          <div>
            <MusicLibrary color="#40101D" size={70} />
            <h4>Canciones que no pueden faltar en nuestra boda</h4>

            <p>
              ¡Estamos deseando escuchar tus temazos favoritos!
              <br />
              Añade todos los que quieras a nuestra lista de reproducción.
            </p>
          </div>

          <SongsFinder onClick={handleSongClick} />
        </div>
      </Content>
    </>
  );
};

export default Music;
